export default __webpack_public_path__ + "static/media/category-price.c93b57cf.jpg";